import * as React from 'react';
import { View } from 'react-native';
import { rem } from 'design-system';
import Text from 'design-system/Text';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import Image from 'utils/packages/rnFastImage';
const BadgeLogo = ({ iconUrl, name }) => {
    const styles = useStyles(styleSet);
    const [image, setImage] = React.useState(iconUrl);
    const latestIconUrlRef = React.useRef(iconUrl);
    React.useEffect(() => {
        latestIconUrlRef.current = iconUrl;
        setImage(iconUrl);
    }, [iconUrl]);
    const handleError = React.useCallback(() => {
        if (latestIconUrlRef.current === image) {
            setImage(undefined);
        }
    }, [image]);
    if (image) {
        return (<Image source={{ uri: image }} style={styles.image} resizeMode="cover" onError={handleError}/>);
    }
    return (<View style={styles.container}>
      <Text Text-10 OnBrand style={styles.initial} centered>
        {name[0] || ' '}
      </Text>
    </View>);
};
export default React.memo(BadgeLogo);
const styleSet = createStyleSheets((colors) => ({
    image: {
        width: rem(16),
        height: rem(16),
        borderRadius: rem(16),
    },
    container: {
        width: rem(16),
        height: rem(16),
        alignItems: 'center',
        borderWidth: rem(1),
        borderRadius: rem(16),
        justifyContent: 'center',
        borderColor: colors.borders.logoStroke,
        backgroundColor: colors.background.brandLight,
    },
    initial: {
        textTransform: 'capitalize',
    },
}));
